import ViolationSelector from "./ViolationSelector/configuration"
import UserInfo from "./UserInfo/configuration"
import RegionCourtSelector from "./RegionCourtSelector/configuration"
import BasicDetails from "./BasicDetails/configuration"
import AttorneySelector from "./AttorneySelector/configuration"
import PaymentDetails from "./PaymentDetails/configuration"
import Complete from "./Complete/configuration"
import Router from "next/router"


const submissionSteps = [
    {
        order: 0,
        ...ViolationSelector
    },
    {
        order: 1,
        ...UserInfo
    },
    {
        order: 2,
        ...RegionCourtSelector
    },
    {
        order: 3,
        ...BasicDetails
    },
    {
        order: 4,
        ...AttorneySelector
    },
    {
        order: 5,
        ...PaymentDetails
    },
    {
        order: 6,
        ...Complete
    }
    // SAMPLE
    // {
    //   order: 2, // The order this screen is shown in
    //   slug: 'user-info', // step name
    //   Component: RegionSelector, // Component to render for this screen
    //   progressBarColor: theme.colors.primary.blue, // this is default
    //   excludeFromprogressBarCount: false, // false is default. Dictates whether to exclude this step from progress bar count.
    //   onExit: async (self) => {}, // called prior to leaving step and passes in store
    //   onEnter: async (self) => {}, // called after setting to this step and passes in store
    //   validateKeys: ['ticketID'] // array of keys to validate prior to allowing screen exit
    //   validatationTarget: self => self.trafficTickets, // pick the store which should be validated
    // }
]

export const getSubmissionSteps = (isSelectedStateAvailable) => {
    if (isSelectedStateAvailable)
        // Example: Move RegionCourtSelector after AttorneySelector
        return submissionSteps
    return [
        {order: 0, ...UserInfo},
        {order: 1, ...BasicDetails},
        {order: 2, ...Complete}
    ]
}

export const getFirstStep = (isStateAvailable) => {
    const steps = getSubmissionSteps(isStateAvailable)
    return steps.reduce((prev, curr) => (!prev || curr.order < prev.order ? curr : prev), null)
}
export const getStepFromSlug = (slug, isStateAvailable) => {
    if (typeof slug !== "string" || !slug.length) return null
    const steps = getSubmissionSteps(isStateAvailable)
    return steps.find((step) => step.slug === slug.toLowerCase()) || getFirstStep(isStateAvailable)
}

export const getNextStep = (currentSlug, isStateAvailable) => {
    const steps = getSubmissionSteps(isStateAvailable)
    const currentStep = getStepFromSlug(currentSlug, isStateAvailable)
    return steps.find((step) => step.order === currentStep?.order + 1) || null
}


export const getPreviousStep = (currentSlug, isStateAvailable) => {
    const steps = getSubmissionSteps(isStateAvailable)
    const currentStep = getStepFromSlug(currentSlug, isStateAvailable)
    if (currentSlug === 'user-info' && !isStateAvailable) {
        Router.push('/traffic-tickets')
    }
    return steps.find((step) => step.order === currentStep?.order - 1) || null
}

export default submissionSteps
